<template>
  <div>
    <form @submit.prevent="handleSubmit(item)">
      <b-row>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.excmdevice.list.filters.idDeviceType') }}:</label>
            <el-select
              id="excmdevice_idDeviceType"
              class="select-default"
              :placeholder="$t('views.excmdevice.list.filters.idDeviceType')"
              filterable
              @input="getDeviceModels"
              v-model="selectedDeviceType">
              <el-option v-for="option in deviceTypes"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.title"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </div>
        </b-col>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.excmdevice.list.filters.idDeviceBrand') }}:</label>
            <el-select
              id="excmdevice_idDeviceType"
              class="select-default"
              :placeholder="$t('views.excmdevice.list.filters.idDeviceBrand')"
              filterable
              @input="getDeviceModels"
              v-model="selectedDeviceBrand">
              <el-option v-for="option in deviceBrands"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.brandTitle"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </div>
        </b-col>
        <b-col cols="12" lg="4">
          <i v-if="loadingModels" class="fas fa-spinner fa-spin center"></i>
          <label
            for="excmdevice_idDeviceModel"
            class="form-control-label">{{$t('views.excmdevice.form.idDeviceModel')}}</label>
          <b-row>
            <b-col class="pr-0">
              <div class="form-group">
                <fg-input :error="violations.idDeviceModel">
                  <el-select
                    id="excmdevice_idDeviceModel"
                    :class="['select-default', isInvalid('idDeviceModel') ? 'select-danger' : '']"
                    :placeholder="$t('views.excmdevice.form.idDeviceModel')"
                    filterable
                    v-model="item.idDeviceModel">
                    <el-option v-for="option in deviceModels"
                               class="select-default"
                               :value="option['@id']"
                               :label="option.idDeviceBrand.brandTitle + ' ' + option.model + ' (' + option.idDeviceType.title + ')'"
                               :key="option['@id']">
                    </el-option>
                  </el-select>
                </fg-input>
                <div
                  v-if="isInvalid('idDeviceModel')"
                  class="invalid-feedback">{{ violations.idDeviceModel }}</div>
              </div>
            </b-col>
            <b-col class="pl-0" cols="3" v-if="ableToCreateDeviceModel">
              <b-btn class="m-0 w-100" style="padding-top: 13px; padding-bottom: 13px;" @click="addNewDeviceModel()" variant="success" v-b-tooltip.hover :title="$t('views.excmdevice.form.addNewDeviceModel')">
                <i class="fas fa-plus"></i>
              </b-btn>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <label
              for="excmdevice_serialNumber"
              class="form-control-label">{{$t('views.excmdevice.form.serialNumber')}}</label>
            <input
              id="excmdevice_serialNumber"
              v-model="item.serialNumber"
              :class="['form-control', isInvalid('serialNumber') ? 'is-invalid' : '']"
              type="text"
              placeholder=""
              @input="handleUpdateField('serialNumber', $event.target.value)">
            <div
              v-if="isInvalid('serialNumber')"
              class="invalid-feedback">{{ violations.serialNumber }}</div>
          </div>
        </b-col>
        <b-col cols="12" lg="4">
          <label
            class="form-control-label">{{$t('views.excmcase.form.contractorUserData')}}</label>
          <div :class="['form-group', isInvalid('contractorUserData') ? 'has-danger' : '']">
            <fg-input :error="violations.contractorUserData">
              <base-select-input
                v-model="item.idContractorUserData"
                :search-callback="userDataSearchCallback"
                :display-values="['fullName', 'firmname1']"
                :query-param="'userdata'"
                :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
              ></base-select-input>
            </fg-input>
          </div>
        </b-col>
        <b-col cols="4" v-if="ableToUpdateUserData">
          <b-btn class="m-0 mt-4 w-100" style="padding-top: 13px; padding-bottom: 13px;" @click="showCreateContractorModal()" variant="success" v-b-tooltip.hover :title="$t('menu.contractors.create')">
            {{$t('menu.contractors.create')}}
          </b-btn>
        </b-col>
      </b-row>
      <b-row v-if="!isAddressTheSame">
        <b-col  sm="8" lg="8">
          <b-alert class="mt-4" show variant="info">{{$t('views.excmdevice.form.addressNotTheSameInfo')}}</b-alert>
        </b-col>
        <b-col  sm="4" lg="4">
          <b-btn class="m-0 mt-4 w-100" style="padding-top: 13px; padding-bottom: 13px;" @click="fillAddressFromContractor()" variant="success" v-b-tooltip.hover :title="$t('menu.contractors.create')">
            {{$t('views.excmdevice.form.fillAddressFromContractor')}}
          </b-btn>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="3">
          <div class="form-group">
            <label
              for="excmdevice_street"
              class="form-control-label">{{$t('views.excmdevice.form.street')}}</label>
            <input
              id="excmdevice_street"
              v-model="item.street"
              :class="['form-control', isInvalid('street') ? 'is-invalid' : '']"
              type="text"
              placeholder=""
              @input="handleUpdateField('street', $event.target.value)">
            <div
              v-if="isInvalid('street')"
              class="invalid-feedback">{{ violations.street }}</div>
          </div>
        </b-col>
        <b-col cols="12" lg="3">
          <div class="form-group">
            <label
              for="excmdevice_city"
              class="form-control-label">{{$t('views.excmdevice.form.city')}}</label>
            <input
              id="excmdevice_city"
              v-model="item.city"
              :class="['form-control', isInvalid('city') ? 'is-invalid' : '']"
              type="text"
              placeholder=""
              @input="handleUpdateField('city', $event.target.value)">
            <div
              v-if="isInvalid('city')"
              class="invalid-feedback">{{ violations.city }}</div>
          </div>
        </b-col>
        <b-col cols="12" lg="3">
          <div class="form-group">
            <label
              for="excmdevice_postcode"
              class="form-control-label">{{$t('views.excmdevice.form.postcode')}}</label>
            <input
              id="excmdevice_postcode"
              v-model="item.postcode"
              :class="['form-control', isInvalid('postcode') ? 'is-invalid' : '']"
              type="text"
              placeholder=""
              @input="handleUpdateField('postcode', $event.target.value)">
            <div
              v-if="isInvalid('postcode')"
              class="invalid-feedback">{{ violations.postcode }}</div>
          </div>
        </b-col>
        <b-col cols="12" lg="3">
          <div class="form-group">
            <label
              for="excmdevice_room"
              class="form-control-label">{{$t('views.excmdevice.form.room')}}</label>
            <input
              id="excmdevice_room"
              v-model="item.room"
              :class="['form-control', isInvalid('room') ? 'is-invalid' : '']"
              type="text"
              placeholder=""
              @input="handleUpdateField('room', $event.target.value)">
            <div
              v-if="isInvalid('room')"
              class="invalid-feedback">{{ violations.room }}</div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="3">
          <div class="form-group">
            <label
              for="excmdevice_building"
              class="form-control-label">{{$t('views.excmdevice.form.building')}}</label>
            <input
              id="excmdevice_building"
              v-model="item.building"
              :class="['form-control', isInvalid('building') ? 'is-invalid' : '']"
              type="text"
              placeholder=""
              @input="handleUpdateField('building', $event.target.value)">
            <div
              v-if="isInvalid('building')"
              class="invalid-feedback">{{ violations.building }}</div>
          </div>
        </b-col>
        <b-col cols="12" lg="3">
          <div class="form-group">
            <label
              for="excmdevice_floor"
              class="form-control-label">{{$t('views.excmdevice.form.floor')}}</label>
            <input
              id="excmdevice_floor"
              v-model="item.floor"
              :class="['form-control', isInvalid('floor') ? 'is-invalid' : '']"
              type="text"
              placeholder=""
              @input="handleUpdateField('floor', $event.target.value)">
            <div
              v-if="isInvalid('floor')"
              class="invalid-feedback">{{ violations.floor }}</div>
          </div>
        </b-col>
        <b-col cols="12" lg="3">
          <div class="form-group">
            <label
              for="excmdevice_longitude"
              class="form-control-label">{{$t('views.excmdevice.form.longitude')}}</label>
            <input
              id="excmdevice_longitude"
              v-model="item.longitude"
              :class="['form-control', isInvalid('longitude') ? 'is-invalid' : '']"
              type="text"
              placeholder=""
              @input="handleUpdateField('longitude', $event.target.value)">
            <div
              v-if="isInvalid('longitude')"
              class="invalid-feedback">{{ violations.longitude }}</div>
          </div>
        </b-col>
        <b-col cols="12" lg="3">
          <div class="form-group">
            <label
              for="excmdevice_latitude"
              class="form-control-label">{{$t('views.excmdevice.form.latitude')}}</label>
            <input
              id="excmdevice_latitude"
              v-model="item.latitude"
              :class="['form-control', isInvalid('latitude') ? 'is-invalid' : '']"
              type="text"
              placeholder=""
              @input="handleUpdateField('latitude', $event.target.value)">
            <div
              v-if="isInvalid('latitude')"
              class="invalid-feedback">{{ violations.latitude }}</div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <button
            type="submit"
            class="btn btn-success">{{$t('buttons.submit')}}</button>
        </b-col>
      </b-row>
    </form>
    <DeviceModelFormModal v-if="ableToCreateDeviceModel"></DeviceModelFormModal>
    <create-contractor-modal v-if="!openedInModal"></create-contractor-modal>
  </div>
</template>

<script>
import CreateContractorModal from '@/components/Dashboard/Views/firm/modals/CreateModal'
import DeviceModelFormModal from '../excmdevicemodel/components/DeviceModelFormModal/DeviceModelFormModal'
import { checkPermission } from '@/utils/checkRoles.js'
import ApiService from '@/utils/ApiService'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput'
import { mapGetters, mapMutations } from 'vuex'
export default {
  props: {
    openedInModal: {
      type: Boolean,
      default: false
    },
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  components: {
    CreateContractorModal,
    DeviceModelFormModal,
    BaseSelectInput
  },

  data () {
    return {
      selectedDeviceType: '',
      selectedDeviceBrand: '',
      contractorUserDataAddress: {},
      deviceTypes: [],
      deviceBrands: [],
      deviceModels: [],
      loadingModels: true
    }
  },
  watch: {
    createdContractor: {
      handler (val) {
        if (val) {
          this.item.idContractorUserData = val['@id']
        }
      }
    },
    'item.idDeviceModel' (val) {
      this.setInitialBrandAndModel(val)
    },
    'item.idContractorUserData' (val) {
      this.fetchContractorUserData(val)
    }
  },
  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },
    violations () {
      return this.errors || {}
    },
    ableToCreateDeviceModel () {
      return this.checkRoles('devices', 'EXCMDeviceModelCreate')
    },
    ableToUpdateUserData () {
      return checkPermission('firms', 'FirmCreate')
    },
    isAddressTheSame () {
      if (this.item.idContractorUserData && this.contractorUserDataAddress && (
        this.item.street !== this.contractorUserDataAddress.street ||
        this.item.city !== this.contractorUserDataAddress.city ||
        this.item.postcode !== this.contractorUserDataAddress.postcode ||
        this.item.latitude !== this.contractorUserDataAddress.latitude ||
        this.item.street.longitude !== this.contractorUserDataAddress.longitude)) {
        return false
      }
      return true
    },
    ...mapGetters({
      createdContractor: 'userdata/create/created'
    })
  },

  created () {
    this.getDeviceBrands()
    this.getDeviceTypes()
    this.getDeviceModels()
    this.channelDeviceModels = this.$store.state.Pusher.subscribe('e_x_c_m_device_models')
    this.channelDeviceModels.bind('e_x_c_m_device_models', data => {
      this.getDeviceModels()
    })
    if (this.item.idContractorUserData) {
      this.fetchContractorUserData(this.item.idContractorUserData)
    }
  },

  methods: {
    ...mapMutations({
      showCreateContractorModal: 'userdata/createModal/toggleModal'
    }),
    setInitialBrandAndModel (idDeviceModel) {
      let deviceModel = this.deviceModels.find(entry => {
        return entry['@id'] === idDeviceModel
      })
      if (deviceModel) {
        this.selectedDeviceBrand = deviceModel.idDeviceBrand['@id']
        this.selectedDeviceType = deviceModel.idDeviceType['@id']
      }
    },
    addNewDeviceModel () {
      this.$store.state.modals.excmdevicemodel.form.show = 1
    },
    fillAddressFromContractor () {
      this.item.street = this.contractorUserDataAddress.street
      this.item.city = this.contractorUserDataAddress.city
      this.item.postcode = this.contractorUserDataAddress.postcode
      this.item.latitude = this.contractorUserDataAddress.latitude
      this.item.longitude = this.contractorUserDataAddress.longitude
    },
    async getDeviceModels () {
      this.loadingModels = true
      let params = {
        pagination: false,
        'order[model]': 'ASC'
      }
      if (this.selectedDeviceBrand) {
        params.idDeviceBrand = this.selectedDeviceBrand
      }
      if (this.selectedDeviceType) {
        params.idDeviceType = this.selectedDeviceType
      }
      const response = await new ApiService('e_x_c_m_device_models', params).getResults()
      this.deviceModels = response.items
      this.loadingModels = false
      this.setInitialBrandAndModel(this.item.idDeviceModel)
    },
    async getDeviceTypes () {
      let params = {
        'pagination': false,
        'state': 1,
        'order[title]': 'ASC'
      }
      this.deviceTypes = []
      const response = await new ApiService('e_x_c_m_device_types', params).getResults()
      this.deviceTypes = response.items
    },
    async getDeviceBrands () {
      let params = {
        pagination: false,
        state: 1,
        'order[brandTitle]': 'ASC'
      }
      this.deviceBrands = []
      const response = await new ApiService('e_x_c_m_device_brands', params).getResults()
      this.deviceBrands = response.items
    },
    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    async userDataSearchCallback (params = {}) {
      let baseParams = { pagination: false, isContractor: 1 }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    async fetchContractorUserData (val) {
      this.contractorUserDataAddress = {}
      const response = await new ApiService(val).getResults()
      if (response) {
        this.contractorUserDataAddress = {
          street: response.street,
          city: response.city,
          postcode: response.postcode,
          latitude: response.latitude,
          longitude: response.longitude
        }
      }
    }
  }
}
</script>
